export const getAccessToken = () => {
    const user = localStorage.getItem('user');
    if (!user) return null;

    try {
        const parsed = JSON.parse(user);
        return parsed?.token || null;
    } catch {
        return null;
    }
}

export const setAccessToken = (token: string) => {
    const user = localStorage.getItem('user');
    if (user) {
        try {
            const parsed = JSON.parse(user);
            parsed.token = token;
            localStorage.setItem('user', JSON.stringify(parsed));
        } catch {
            localStorage.setItem('user', JSON.stringify({ token }));
        }
    } else {
        localStorage.setItem('user', JSON.stringify({ token }));
    }
}

export const removeAccessToken = () => {
    localStorage.removeItem('user');
}

export const getStoredUser = () => {
    const user = localStorage.getItem('user');
    if (!user) return null;

    try {
        return JSON.parse(user);
    } catch {
        return null;
    }
}

export const setStoredUser = (userData: any) => {
    localStorage.setItem('user', JSON.stringify(userData));
}